<div class="status-container" [ngClass]="type">
    <p class="status-text" *ngIf="title">{{ 'dimbo.i18n.error.critical' | translate}}</p>
    <p class="status-text" >{{ message }}</p>
    <button mat-raised-button class="cancel-btn" (click)="closeTab()">{{'dimbo.i18n.brandcareForm.button.close' | translate}}</button>
  </div>
